/* eslint-disable unused-imports/no-unused-vars-ts */
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { appConfig } from "../constant/app.constant";
import { SpinnerService } from "./spinner.service";

@Injectable({ providedIn: "root" })
export class LeadTimeService {
  private _url = `${appConfig.BASE_URL}ReturnPortalFacade`;

  constructor(private httpClient: HttpClient, private spinnerService: SpinnerService) {}

  getExceptionDates(request: any) {
    this.spinnerService.show();

    const result = this.httpClient.post(`${this._url}/GetExceptionDates`, request).pipe(
      tap(
        (response) => this.spinnerService.hide(),
        (error: any) => this.spinnerService.hide()
      )
    );
    return result;
  }
}
